import { render, staticRenderFns } from "./DropdownContent.vue?vue&type=template&id=66403d69"
import script from "./DropdownContent.vue?vue&type=script&lang=ts"
export * from "./DropdownContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66403d69')) {
      api.createRecord('66403d69', component.options)
    } else {
      api.reload('66403d69', component.options)
    }
    module.hot.accept("./DropdownContent.vue?vue&type=template&id=66403d69", function () {
      api.rerender('66403d69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/sidebaritems/DropdownContent.vue"
export default component.exports